<!-- кнопка одной операции в колонке операций в компоненте List -->
<template>
	<!-- для мобил -->
	<div v-if="Object.keys(data).length > 0 && $store.state.windowWidth <= 767" class="w5-opers-button-for-mobile">
		<!-- кнопка редактирования -->
		<div v-if="'update' in data" @click.stop="clickOper('update')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="pencil-alt" />
		</div>

		<!-- кнопка удаления -->
		<div v-if="'delete' in data" @click.stop="clickOper('delete')" class="w5-opers-button-curd-btn">
			<font-awesome-icon icon="trash-alt" class="color-red" />
		</div>
	</div>

	<!-- для десктопов -->
	<div v-else-if="Object.keys(data).length > 0 && $store.state.windowWidth > 767" :data-index="index">
		<!-- кнопка редактирования -->
		<span v-if="canShowCrudButton && 'update' in data"
			class="w5-dropdown-menu-item w5-opers-button-one-btn"
			:title="data['update']['title'] ? data['update']['title'] : 'main/update' | ftc"
			@click.stop="clickOper('update')">
			<font-awesome-icon icon="pencil-alt" />
		</span>

		<!-- кнопка удаления последняя -->
		<span v-if="canShowCrudButton && 'delete' in data"
			class="w5-dropdown-menu-item w5-opers-button-one-btn"
			:title="data['delete']['title'] ? data['delete']['title'] : 'main/delete' | ftc"
			@click.stop="clickOper('delete')">
			<font-awesome-icon icon="trash-alt" class="color-red" />
		</span>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'listOneOperButtonComponent',
	//=========================================================================
	// данные - пункты меню
	//=========================================================================
	props: ['dataConfig', 'row', 'index', 'crud'],
	//=========================================================================
	// локальные переменные
	//=========================================================================
	data() {
		return {
			// данные
			data: {},
			// строка - заводим ее, так как она может меняться родителем
			Row: null
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		statusTextField() {
			if (!this.Row) return false
			// ищем в строке колонку со статусом процесса
			let _statusField = false
			// ищем в первой строке
			for (let _s in this.Row)
			{
				// если это поле статуса
				if (/_status_text$/ig.test(_s))
				{
					_statusField = _s
					break
				}
			}

			return _statusField
		},
		canShowCrudButton() {
			// если нет строки - нельзя
			if (!this.Row) return false

			// смотрим статус процесса
			let _text = this.statusTextField
			// если его нет - можно
			// кроме пользователей
			if (!_text || this.crud === 'user') return true
			// если статус есть и он не пустой - нельзя
			if (this.Row[_text]) return false

			// по умолчанию можно
			return true
		}
	},
	//=========================================================================
	// кмопонент создан
	//=========================================================================
	created() {
		this.Row = this.row
		this.initButtons()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		EventBus.$on('w5-update-row', this.updateRowHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-update-row', this.updateRowHandler)
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// кликнули по пункту меню
		//---------------------------------------------------------------------
		clickOper(action) {
			let _action = this.data[action]
			if (this.crud === 'user' && this.$store.state.user_type !== 'admin')
			{
				if (action === 'update' && this.Row['user_id'] === this.$store.state.user_id)
					_action = { 'action': 'url:/options' }
			}

			this.$emit('action', {
				'action': action,
				'data': _action,
				'row': this.Row
			})
		},
		//---------------------------------------------------------------------
		// инициализация данных
		//---------------------------------------------------------------------
		initButtons() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// копируем свойства
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.data = Object.assign({}, this.dataConfig)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция DELETE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('delete' in this.data)
			{
				let _canDel = false
				// определим если есть точное указание в записи
				if ('can_delete' in this.Row)
				{
					// есть поле "can_delete", смотрим на его значение
					_canDel = Helper.normalizeBooleanValue(this.Row['can_delete'])
				}
				else
				{
					// прямого указания нет - считаем что запись можно удалять
					_canDel = true
					// если это операции - то все наоборот
					if (this.crud === 'operation') _canDel = false
					// такого специального поля нет - ищем в других полях статус записи
					for (let nm in this.Row) if (this.Row.hasOwnProperty(nm))
					{
						if (nm.indexOf('_status') >= 0 && String(this.Row[nm]).indexOf('delete') >= 0)
						{
							// нашли такое поле - значит запись со статусом "удалена"
							_canDel = false
							break
						}
					}
				}

				// проверка прав доступа
				if (!this.isAccess(this.crud + '/delete')) _canDel = false

				// итого, если удалять нельзя - уберем из данных
				if (_canDel === false) this.$delete(this.data, 'delete')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция UPDATE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('update' in this.data)
			{
				let _canUpd = false
				if (this.crud === 'operation' && this.$store.state.user_type !== 'admin') _canUpd = false
				else if (this.crud === 'user' && this.$store.state.user_type !== 'admin')
				{
					if (this.Row['user_id'] === this.$store.state.user_id) _canUpd = true
					else
					{
						if ('can_update' in this.Row && !this.Row['can_update'])
						{
							_canUpd = false
						}
						else
						{
							_canUpd = true
							// проверка прав доступа
							if (!this.isAccess(this.crud + '/update')) _canUpd = false
						}
					}
				}
				else
				{
					if (('can_update' in this.Row && !this.Row['can_update']) ||
						this.crud === 'vds' || this.crud === 'additional-services' ||
						(this.crud === 'request' && this.$store.state.user_type !== 'admin'))
					{
						_canUpd = false
					}
					else
					{
						_canUpd = true
						// проверка прав доступа
						if (!this.isAccess(this.crud + '/update')) _canUpd = false
					}
				}

				// итого, если редактировать нельзя - уберем из данных
				if (_canUpd === false) this.$delete(this.data, 'update')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем - допустима ли операция CREATE
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('create' in this.data)
			{
				let _canCrt = true

				// проверка прав доступа
				let _crud = this.crud
				if (this.crud === 'servicetype') _crud = 'plan'
				if (!this.isAccess(_crud + '/create')) _canCrt = false

				if (_canCrt && this.crud === 'servicetype')
					if (!('can_create_plan' in this.Row) || this.Row['can_create_plan'] !== true) _canCrt = false

				// итого, если создавать нельзя - уберем из данных
				if (_canCrt === false) this.$delete(this.data, 'create')
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// изменилась строка
		//---------------------------------------------------------------------
		updateRowHandler(data) {
			// проверка входящих данных
			if (!data || !data['column_id'] || !data['row']) return
			// если это не наша строка
			if (this.Row[data['column_id']] !== data['row'][data['column_id']]) return
			// переинициализация
			this.Row = data['row']
			this.initButtons()
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'row': function(row) {
			this.Row = row
			this.initButtons()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-opers-button-one-btn {
	display: inline-block;
	margin: 0 15px 0 0;
	cursor: pointer;
}
.w5-opers-button-one-btn:last-of-type {
	margin-right: 0;
}
.w5-opers-button-one-btn svg {
	font-size: 14px;
	color: #2880da;
	margin: 0;
}
.w5-application.mc .w5-opers-button-one-btn svg {
	color: #3250ba;
}
</style>



// WEBPACK FOOTER //
// oneoper.vue?0fa7b096